import React from 'react'
import PropTypes from 'prop-types'

export const FeatureContext = React.createContext()
export const FeatureConsumer = FeatureContext.Consumer

const FeatureProvider = ({ features, ...props }) => {
  return <FeatureContext.Provider value={features} {...props} />
}

FeatureProvider.defaultProps = {
  features: {},
}

FeatureProvider.propTypes = {
  features: PropTypes.object,
}

FeatureProvider.displayName = 'FeatureProvider'
FeatureContext.displayName = 'FeatureContext'

export default FeatureProvider
